const initialState = {
  id: null,
  refreshToken: null,
  accessToken: null,
  username: null,
  email: null,
  rankingPoints: null,
  rankingPosition: null,
  nextUsernameChangeAt: null,
  // False until `/users/me/` says otherwise: nothing is walked anywhere on a guess.
  basicTrainingPending: false,
  isGuest: false,
  isStaff: false,
}

export default initialState
